import { useMemo } from 'react';
import { createT, dirOf, type Dir, type Locale, type StringKey, type TFunction, tDynamic, type Vars } from '@castfeeds/i18n';
import { usePrefs } from '@/store/prefs';

export interface I18n {
  t: TFunction;
  /** For keys built at runtime, e.g. `role_${role}`; falls back to the raw value. */
  td: (key: string, fallback?: string, vars?: Vars) => string;
  locale: Locale;
  dir: Dir;
}

export function useT(): I18n {
  const locale = usePrefs((s) => s.locale);
  return useMemo(() => ({ t: createT(locale), td: (k: string, f?: string, v?: Vars) => tDynamic(locale, k, f, v), locale, dir: dirOf(locale) }), [locale]);
}

export type { StringKey };
